'use strict';

/**
 * @ngdoc overview
 * @name ribytRsvpApp
 * @description
 * # ribytRsvpApp
 *
 * Main module of the application.
 */
angular
    .module( 'ribytRsvpApp', [
        'config',
        'ngBootbox',
        'ngAnimate',
        'ngCookies',
        'ngResource',
        'ngRoute',
        'ngSanitize',
        'ngTouch',
        'picardy.fontawesome',
        'ngLodash',
        'ui.router',
        'ui.mask',
        'ui.bootstrap',
        'jlareau.pnotify',
        'ngStorage',
        'angularMoment',
        'ngCropper',
        'infinite-scroll',
        'toggle-switch'
    ] )
    .config( function ( $stateProvider, $urlRouterProvider, $urlMatcherFactoryProvider, $locationProvider, $qProvider ) {
        $urlRouterProvider.otherwise( '/' );
        // add blank hashbang as angular 1.6.0 adds ! by default
        $locationProvider.hashPrefix( '' );
        // prevent unhandled promise errors in console from raven due to 1.6.0 changes
        $qProvider.errorOnUnhandledRejections( false );
        $urlRouterProvider.rule( function ( $injector, $location ) {
            var path = $location.path();
            var hasTrailingSlash = path[path.length - 1] === '/';

            if ( hasTrailingSlash && path !== '/' ) {
                return path.substr( 0, path.length - 1 );
            }
        } );

        $stateProvider
            .state( 'main', {
                // main abstract route
                'abstract': true,
                'controller': 'MainCtrl',
                'controllerAs': 'main',
                'templateUrl': 'views/main.html',
                'resolve': {
                    'invite': function ( mainInviteRequest ) {
                        return mainInviteRequest.getInvite();
                    }
                }
            } )
            // do nothing, main MainCtrl is loaded here on app entrance for all routes
            .state( 'main.entrance', {
                'template': '<ui-view></ui-view>',
                'url': '/'
            } )
            .state( 'main.permission', {
                'url': '/permission?{inviteHash:string}&{preview:string}&{gid:string}&{rsvpStatus:string}',
                'templateUrl': 'views/permission.html',
                'controller': 'PermissionCtrl',
                'controllerAs': 'permission',
                'rsvpProcess': 'permission'
            } )
            .state( 'main.introduction', {
                'url': '/introduction?{inviteHash:string}&{preview:string}&{gid:string}&{rsvpStatus:string}',
                'templateUrl': 'views/introduction.html',
                'controller': 'IntroductionCtrl',
                'controllerAs': 'introduction',
                'rsvpProcess': 'introduction'
            } )
            .state( 'main.personalInformation', {
                'url': '/personalInformation?{inviteHash:string}&{preview:string}&{gid:string}&{rsvpStatus:string}',
                'templateUrl': 'views/personalinformation.html',
                'controller': 'PersonalinformationCtrl',
                'controllerAs': 'personalInformation',
                'rsvpProcess': 'guestProfile'
            } )
            .state( 'main.legalForms', {
                'url': '/legalForms?{inviteHash:string}&{preview:string}&{gid:string}&{rsvpStatus:string}',
                'templateUrl': 'views/legalforms.html',
                'controller': 'LegalformsCtrl',
                'controllerAs': 'legalForms',
                'rsvpProcess': 'legalForms'
            } )
            .state( 'main.payment', {
                'url': '/payment?{inviteHash:string}&{preview:string}&{gid:string}&{rsvpStatus:string}',
                'templateUrl': 'views/payment.html',
                'controller': 'PaymentCtrl',
                'controllerAs': 'payment',
                'rsvpProcess': 'payment'
            } )
            .state( 'main.companionInvitation', {
                'url': '/companionInvitation?{inviteHash:string}&{preview:string}&{gid:string}&{rsvpStatus:string}',
                'templateUrl': 'views/companioninvitation.html',
                'controller': 'CompanioninvitationCtrl',
                'controllerAs': 'companionInvitation',
                'rsvpProcess': 'companionInvitation'
            } )
            /**
             * So this one is weird. I have it pointing to introduction since
             * the data to display is already done there and we're only modifying
             * the right side content. That logic is built into the introduction.html
             * and is fairly unobtrusive so I'm just going to keep it this way so
             * we dont' have to duplicate the controller logoc to populate all
             * the data for the event. I don't think it's worth breaking out into
             * a provider.
             */
            .state( 'main.complete', {
                'url': '/complete?{inviteHash:string}&{preview:string}&{gid:string}&{rsvpStatus:string}',
                'templateUrl': 'views/introduction.html',
                'controller': 'IntroductionCtrl',
                'controllerAs': 'introduction',
                'rsvpProcess': 'welcome'
            } )
            .state( 'main.itinerary', {
                'url': '/itinerary?{inviteHash:string}&{preview:string}&{gid:string}&{rsvpStatus:string}',
                'templateUrl': 'views/itinerary.html',
                'controller': 'ItineraryCtrl',
                'controllerAs': 'itinerary',
                'rsvpProcess': 'itinerary'
            } )
            .state( 'main.ticket', {
                'url': '/ticket?{inviteHash:string}&{preview:string}&{gid:string}&{rsvpStatus:string}&{showTicket:string}',
                'templateUrl': 'views/ticketPage.html',
                'controller': 'TicketCtrl',
                'controllerAs': 'ticket',
                'rsvpProcess': 'ticket',
                'showTicket': 'true'
            } )
            .state( 'error', {
                'url': '/error?{inviteHash:string}&{preview:string}&{gid:string}&{rsvpStatus:string}',
                'templateUrl': 'views/error.html',
                'controller': 'ErrorCtrl',
                'controllerAs': 'error',
                'params': {
                    'message': null
                }
            } );
    } )
    .run( function ( $window, $rootScope, $sessionStorage, $location, $state, $http, ENV, notificationService, $timeout, AWS, messageDictionary ) {
        /**
         * Global $rootScope vars
         */

        $rootScope.isTranslationEnabled = Boolean( ENV.featureToggles.translation );

        // Show our container
        $( '.container' ).show();
        /**
         * Just some useful global stuff here. $rootScope first
         */
        // Set the decryptInvite
        $rootScope.decryptInvite = function ( data ) {
            // check if the item is parseable
            try {
                return JSON.parse( v( data || _.get( $sessionStorage, 'invitation' ), 'zq6tX4rBRwA' ) );
            } catch ( e ) {
                return false;
            }
        };

        $rootScope.goTo = function ( $event, tab ) {
            var invitation = $rootScope.decryptInvite( _.get( $sessionStorage, 'invitation' ) );
            if ( tab === 'guestProfile' ) {
                tab = 'personalInformation';
            }

            if (
                (invitation.experienceID.RSVPDetails.isExperiencePassword || invitation.experienceID.RSVPDetails.isRegistrationLimited)
                && _.get( $rootScope, 'parameters.rsvpStatus' ) === 'n'
            ) {
                tab = 'permission';
            }


            return $state.go( 'main.' + tab, {
                'inviteHash': _.get( $rootScope, 'inviteHash', null ),
                'preview': _.get( $rootScope, 'parameters.preview' ),
                'rsvpStatus': _.get( $rootScope, 'parameters.rsvpStatus' ),
                'showTicket': 'true',
                'completed': true
            } );
        }

        // AWS helper
        $rootScope.AWS = AWS;

        // Encrypt and decrypt is the same.
        $rootScope.encryptInvite = function ( data ) {
            return v( JSON.stringify( data ), 'zq6tX4rBRwA' );
        };

        $rootScope.setHeaderBanner = function ( invite, type ) {
            if ( invite && invite.images && invite.images.length > 0 ) {
                // Display the correct banner image
                var bannerFile = _.find( invite.images, function ( image ) {
                    return image.id === _.get( invite, type === 'itinerary' ? 'experienceID.itineraryDetails.headerFileID' : 'experienceID.RSVPDetails.fileID' );
                } );
                if ( _.has( bannerFile, 'awsPath' ) ) {
                    var bannerImage = angular.element( '#bannerImage' );
                    $rootScope.bannerImageUrl = 'https://s3-us-west-2.amazonaws.com/ribyt/cdn/' + bannerFile.awsPath;
                    // bannerImage.attr( 'src', $rootScope.bannerImage );
                    bannerImage.css({'width': '100%'});
                }
            }
        };

        $rootScope.getImagePath = function(invite, imagePath){
            if ( invite && invite.images && invite.images.length > 0 ) {
                // Display the correct banner image
                var imageFile = _.find( invite.images, function ( image ) {
                    return image.id === _.get( invite, imagePath );
                } );
                if ( _.has( imageFile, 'awsPath' ) ) {
                    return 'https://s3-us-west-2.amazonaws.com/ribyt/cdn/' + imageFile.awsPath;
                }
                return null;
            }
            return null;
        };

        $rootScope.getTicketBannerImagePath = function( invite, ticketData, imagePath ) {
            if ( invite && invite.images && invite.images.length > 0 ) {
                // Display the correct banner image
                var imageFile = _.find( invite.images, function ( image ) {
                    return image.id === _.get( ticketData, imagePath );
                } );
                if ( _.has( imageFile, 'awsPath' ) ) {
                    return 'https://s3-us-west-2.amazonaws.com/ribyt/cdn/' + imageFile.awsPath;
                }
                return null;
            }
            return null;
        };

        $rootScope.setSupportInfo = function ( invite ) {
            $rootScope.supportInfo = _.get( invite, 'eventID.supportInfo' );
        };

        $rootScope.adjustPlural = function ( qty, item ) {
            if ( qty > 1 ) {
                return qty + ' ' + $rootScope.makePlural( item );
            } else {
                return qty + ' ' + $rootScope.makeSingular( item );
            }
        };

        $rootScope.makePlural = function ( item ) {
            if ( item !== 'Other' && item !== 'admittance for' ) {
                // if there is no 's', add it
                if ( !( item.substr( -1 ) === 's' ) ) {
                    return item + 's';
                } else { // it's already plural
                    return item;
                }
            } else {
                return item;
            }
        };

        $rootScope.makeSingular = function ( item ) {
            if ( item !== 'Other' ) {
                // if there is an 's', remove it
                if ( item.substr( -1 ) === 's' ) {
                    return item.slice( 0, -1 );
                } else {
                    return item;
                }
            } else {
                return item;
            }
        };

        /**
         * This function redirects the user to the proper state that matches
         * the invite rsvpProcess.
         *
         * @param  {object} invite [description]
         * @return {bool}        [description]
         */
        $rootScope.redirectProperly = function redirect ( invite, options ) {
            options = options || {};
            /**
             * See where they need to go if rsvpProcess is set.
             */
            if ( _.get( $rootScope, 'parameters.showTicket' ) ) {

                var hasTickets = invite.byts.find( function findTicket ( byt ) {
                    return byt.type === 'Ticket' && byt.isEnabled;
                } );
                if ( invite.rsvp === 'y' && hasTickets ) {
                    return $state.go( 'main.ticket', {
                        'inviteHash': _.get( $rootScope, 'inviteHash', null ),
                        'preview': _.get( $rootScope, 'parameters.preview' ),
                        'gid': _.get( $rootScope, 'parameters.gid' ),
                        'rsvpStatus': _.get( $rootScope, 'parameters.rsvpStatus' ),
                        'showTicket': 'true'
                    }, options );
                } else {
                    $rootScope.bannerImage = false;
                    $rootScope.hideTabs = true;
                    return $state.go( 'error', { 'message': 'Sorry, you do not have any valid tickets for this event.' } );
                }
            } else if ( _.get( invite, 'rsvpProcess' ) ) {
                // Check all states for a path
                var newState = _.find( $state.get(), {
                    'rsvpProcess': _.get( invite, 'rsvpProcess' )
                } );

                // Set the currentTab to the rsvpProcess
                _.set( $rootScope, 'currentTab', _.get( invite, 'rsvpProcess' ) );
                // if the itinerary is ready and the guest has said yes, send them to itinerary
                // otherwise, send them wehere they need to go
                if ( (
                        _.get( invite, 'dateEmailReadyToSend', null ) &&
                        _.get( invite, 'rsvp', 'p' ) === 'y' ) ||
                    _.get( $rootScope, 'parameters.preview' )
                ) {
                    return $state.go( 'main.itinerary', {
                        'inviteHash': _.get( $rootScope, 'inviteHash', null ),
                        'preview': _.get( $rootScope, 'parameters.preview' ),
                        'gid': _.get( $rootScope, 'parameters.gid' ),
                        'rsvpStatus': _.get( $rootScope, 'parameters.rsvpStatus' )
                    }, options );
                } else if ( newState && _.get( newState, 'rsvpProcess' ) === _.get( invite, 'rsvpProcess' ) ) {
                    if (
                        _.get( newState, 'name' ) === 'main.legalForms' &&
                        !$rootScope.isHasLegals( invite )
                    ) {
                        if ( invite.type === 'g' ) {
                            return $state.go( 'main.complete', {
                                'inviteHash': _.get( $rootScope, 'inviteHash', null ),
                                'gid': _.get( $rootScope, 'parameters.gid' ),
                                'rsvpStatus': _.get( $rootScope, 'parameters.rsvpStatus' )
                            }, options );
                        } else if ( $rootScope.isHasCompanionsRemaining( invite ) ) {
                            return $state.go( 'main.companionInvitation', {
                                'inviteHash': _.get( $rootScope, 'inviteHash', null ),
                                'gid': _.get( $rootScope, 'parameters.gid' ),
                                'rsvpStatus': _.get( $rootScope, 'parameters.rsvpStatus' )
                            }, options );
                        } else if ( $rootScope.isHasLegals( invite ) ) {
                            return $state.go( 'main.legalForms', {
                                'inviteHash': _.get( $rootScope, 'inviteHash', null ),
                                'gid': _.get( $rootScope, 'parameters.gid' ),
                                'rsvpStatus': _.get( $rootScope, 'parameters.rsvpStatus' )
                            }, options );
                        } else {
                            return $state.go( 'main.complete', {
                                'inviteHash': _.get( $rootScope, 'inviteHash', null ),
                                'gid': _.get( $rootScope, 'parameters.gid' ),
                                'rsvpStatus': _.get( $rootScope, 'parameters.rsvpStatus' )
                            }, options );
                        }
                    } else {
                        // Case when we require enter password on rsvp yes
                        if ( invite.experienceID.RSVPDetails.isExperiencePassword && !$rootScope.passwordAccepted && _.get( $rootScope, 'parameters.rsvpStatus' ) === 'y' ) {
                            if ( $state.current.name !== 'main.entrance' ) {
                                $rootScope.navigatedState = $state.current.name;
                            }
                            return $state.go( 'main.permission', {
                                'inviteHash': _.get( $rootScope, 'inviteHash', null ),
                                'gid': _.get( $rootScope, 'parameters.gid' ),
                                'rsvpSkip': _.get( $rootScope, 'parameters.rsvpSkip' ),
                                'rsvpStatus': _.get( $rootScope, 'parameters.rsvpStatus' )
                            }, options );
                        } else {
                            return $state.go( _.get( newState, 'name', 'main.introduction' ), {
                                'inviteHash': _.get( $rootScope, 'inviteHash', null ),
                                'gid': _.get( $rootScope, 'parameters.gid' ),
                                'rsvpSkip': _.get( $rootScope, 'parameters.rsvpSkip' ),
                                'rsvpStatus': _.get( $rootScope, 'parameters.rsvpStatus' )
                            }, options );
                        }
                    }
                } else {
                    return $state.go( 'error', {
                        'message': 'Sorry but there seems to be an error.',
                        'inviteHash': _.get( $rootScope, 'inviteHash', null ),
                        'gid': _.get( $rootScope, 'parameters.gid' ),
                        'rsvpStatus': _.get( $rootScope, 'parameters.rsvpStatus' )
                    }, options );
                }
            } else if ( _.get( $rootScope, 'parameters.invite' ) ) {
                var params = {
                    'inviteHash': _.get( $rootScope, 'inviteHash', null ),
                    'gid': _.get( $rootScope, 'parameters.gid' ),
                    'rsvpStatus': _.get( $rootScope, 'parameters.rsvpStatus' )
                };

                if ( _.get( params, 'rsvpStatus' ) === 'n' ) {
                    params.rsvpProcess = 'welcome';
                }

                // if there is a passed invite in the parameters, this is an itinerary preview with custom invite
                return $state.go( 'main.itinerary', params );
            } else if ( _.get( $rootScope, 'parameters.rsvpStatus' ) === 'n' ) {
                // set invite to no and mark rsvpProcess as welcome because we're done
                invite.rsvp = 'n';
                invite.rsvpProcess = 'welcome';
                $rootScope.redirectProperly( invite );
            } else if ( invite.experienceID.RSVPDetails.isExperiencePassword || invite.experienceID.RSVPDetails.isRegistrationLimited ) {
                var currentState = $state.current.name;
                if ( $state.current.name !== 'main.entrance' ) {
                    $rootScope.navigatedState = $state.current.name;
                }
                return $state.go( 'main.permission', {
                    'inviteHash': _.get( $rootScope, 'inviteHash', null ),
                    'gid': _.get( $rootScope, 'parameters.gid' ),
                    'rsvpSkip': _.get( $rootScope, 'parameters.rsvpSkip' ),
                    'rsvpStatus': _.get( $rootScope, 'parameters.rsvpStatus' )
                }, options );
            } else {
                return $state.go( 'main.introduction', {
                    'inviteHash': _.get( $rootScope, 'inviteHash', null ),
                    'gid': _.get( $rootScope, 'parameters.gid' ),
                    'rsvpStatus': _.get( $rootScope, 'parameters.rsvpStatus' )
                }, options );
            }
        };

        $rootScope.accept = function ( invite ) {
            var data = {
                rsvpProcess: $rootScope.rsvpProcess === 'welcome' ? 'welcome' : 'guestProfile',
                RSVPUserAgent: _.get( $window, 'navigator.userAgent' ),
                inviteID: _.get( invite, 'id' )
            };

            if ( $rootScope.currentRsvpStatus === 'p' || $rootScope.currentRsvpStatus === 'n' ) {
                data.rsvpOnly = 'y';
                data.rsvp = 'p';
                data.rsvpProcess = 'guestProfile';
            } else {
                data.rsvp = 'y';
            }

            if ( _.get( $rootScope, 'parameters.gid' ) ) {
                _.set( invite, 'rsvpProcess', 'guestProfile' );
                _.set( $sessionStorage, 'invitation', $rootScope.encryptInvite( invite ) );
                $rootScope.redirectProperly( invite );
            } else {
                $http.put( ENV.apiEndpoint + '/ribyt/rsvp/' + $sessionStorage.inviteHash, data )
                     .then( function success ( ) {
                         console.log( 'success changing stage' );

                         // Decrypt and localize
                         var invite = $rootScope.decryptInvite( _.get( $sessionStorage, 'invitation' ) );
                         invite.rsvp = data.rsvp;
                         $rootScope.rsvpProcess = data.rsvpProcess;
                         _.set( invite, 'rsvpProcess', data.rsvpProcess );

                         _.set( $sessionStorage, 'invitation', $rootScope.encryptInvite( invite ) );

                         $rootScope.redirectProperly( invite );
                     }, function error ( ) {
                         notificationService.error( messageDictionary.error.inviteSaveIssue );
                     } );
            }
        };

        $rootScope.getEventLocation = function ( event ) {
            // Setup the location
            var eventLocation = '';
            var locationVenue = _.get( event, 'location.venue', null );

            if ( locationVenue ) {
                eventLocation += locationVenue;
            } else {
                var eventCity = _.get( event, 'location.city', null );
                var eventState = _.get( event, 'location.state', null );

                if ( eventCity ) {
                    eventLocation += eventCity;
                }

                if ( eventState ) {
                    eventLocation += ', ' + eventState;
                }
            }
            return eventLocation;
        };

        /**
         * This function takes an unencrypted invite and determines the next RSVP process
         * step and returns it.
         */
        $rootScope.getNextRSVPProcess = function ( invite ) {
            /**
             * Steps at this point (2016-05-13) should be:
             *
             * introduction (rsvp y or n),
             * guestProfile
             * legalForms
             * companionInvitation
             * welcome (final page)
             */
            switch ( _.get( invite, 'rsvpProcess' ) ) {
            case 'guestProfile':
                if ( $rootScope.isHasLegals( invite ) ) {
                    return 'legalForms';
                } else if ( $rootScope.isHasCompanionsRemaining( invite ) && ( _.get( invite, 'type' ) == 'i' ) ) {
                    return 'companionInvitation';
                } else {
                    return 'welcome';
                }
            case 'legalForms':
                if ( $rootScope.isHasCompanionsRemaining( invite ) && ( _.get( invite, 'type' ) == 'i' ) ) {
                    return 'companionInvitation';
                } else {
                    return 'welcome';
                }
            case 'welcome':
            case 'companionInvitation':
                return 'welcome';
            default:
                return 'introduction';
            }
        };

        /**
         * Check to see if any of the personal info fields are set to true.
         * If they are then we return true as that page needs to be shown.
         * @param {*} invite
         */
        $rootScope.isPersonalInformationRequired = function ( invite ) {
            var required = false;
            var infoFields = _.get( invite, 'experienceID.guestInformation.params', [] );
            if ( _.get( invite, 'experienceID.guestInformation.surveyQuestions', [] ).length ) {
                required = true;
            }

            if ( _.some( _.get( infoFields, 'contact.phone' ) ) ) {
                required = true;
            }
            delete infoFields.contact.phone;

            if ( _.some( _.get( infoFields, 'personal' ) ) ) {
                required = true;
            }

            if ( _.some( _.values( _.get( infoFields, 'contact', {} ) ) ) ) {
                required = true;
            }

            if ( _.some( _.get( infoFields, 'travel' ) ) ) {
                required = true;
            }

            return required;
        };

        $rootScope.isHasCompanionsRemaining = function ( invite ) {
            if (
                ( _.get( invite, 'experienceID.additionalGuests', 0 ) >
                ( _.get( invite, 'companionInfoIDs', [] ).filter( function ( companion ) {
                    return !companion.exludedOnRSVP;
                } ).length + _.get( invite, 'guestsNotInvited', 0 ) ) ) &&
                _.get( invite, 'type' ) === 'i'
            ) {
                return true;
            } else {
                return false;
            }
        };

        $rootScope.isHasCompanions = function ( invite ) {
            if (
                _.get( invite, 'experienceID.additionalGuests', 0 ) && _.get( invite, 'type' ) === 'i'
            ) {
                return true;
            } else {
                return false;
            }
        };

        $rootScope.isHasLegals = function ( invite ) {
            /* so, if we have some signed documents already, check that we have signed
            all the required ones from the group. if for example, there is a legal
            that was added after the guest has signed, and somehow they were told to
            go through the sign up process again, they would be presented with the
            ability to sign the legal documents, because there is one that they have
            not signed yet. At this point, they will need to re-sign any other legal
            documents they may have signed already. Direction hasn't been given with
            this situation, but this will allow for an easy way to keep all the signed
            legals in one PDF when the user chooses to download it. Also, for the
            possibility for sending updated legals to be signed in the future.
            */

            // TLDR; we should check if they have signed all the legals for the experience. if it has been modified, we should allow them to resign it

            var typeOfInvite = invite.type === 'i' ? 'guest' : 'companion';
            var legalsWeWantSigned = _.filter( _.get( invite, 'experienceID.legals', [] ), function ( legal ) {
                return legal.type[typeOfInvite];
            } );
            // get the last in the array of the hellosign objects. If for some reason they had signed more than one set, the last item will be the most recent one
            var legalsAlreadySigned = _.last( _.get( invite, 'helloSign', [{}] ) );

            // if there are legals already signed, make sure they signed all the required ones, according to the experience
            if ( _.get( legalsAlreadySigned, 'length' ) > 0 ) {
                _.each( legalsWeWantSigned, function ( legal, index ) {
                    if ( _.find( legalsAlreadySigned.legals, function ( signedLegal ) { return signedLegal.id === legal.legalID; } ) ) {
                        legalsWeWantSigned[index].signed = true;
                    } else {
                        legalsWeWantSigned[index].signed = false;
                    };
                } );
            }
            if ( _.get( legalsAlreadySigned, 'event', null ) === 'signature_request_signed' ) {
                // check if all the legals in the experience are signed
                if ( _.every( legalsWeWantSigned, {'signed': true} ) ) {
                    return true;
                } else {
                    return false;
                }
            } else if ( _.every( legalsWeWantSigned, {'signed': true} ) ) {
                return false;
            } else {
                return true;
            }
        };

        $rootScope.isFinishedRSVPProcess = function ( invite ) {
            return !$rootScope.isHasCompanionsRemaining( invite ) &&
                !$rootScope.isHasLegals( invite ) &&
                ( _.get( invite, 'rsvpProcess' ) === 'welcome' || _.get( invite, 'rsvpProcess' ) === 'legalForms' );
        };

        $rootScope.setRSVPToYes = function ( invite, cb ) {
            if ( !_.get( $rootScope, 'hasSetRSVPToYes', false ) && _.has( invite, 'inviteHash' ) ) {
                var data = {
                    'rsvp': 'y',
                    'rsvpProcess': 'welcome'
                };

                _.set( $rootScope, 'hasSetRSVPToYes', true );
                _.set( $rootScope, 'rsvpProcess', 'welcome' );

                $http.put( _.get( ENV, 'apiEndpoint', 'http://localhost:1338' ) + '/ribyt/rsvp/' + _.get( invite, 'inviteHash' ), data )
                    .then( function success ( response ) {
                        if ( cb ) {
                            cb( null, response );
                        }
                    }, function ( response ) {
                        if ( cb ) {
                            cb( response );
                        }
                    } );
            }
        };

        $rootScope.decline = function ( cb ) {
            var data = {
                'rsvp': 'n',
                'rsvpProcess': 'welcome',
                'RSVPUserAgent': _.get( $window, 'navigator.userAgent' )
            };

            _.set( $rootScope, 'rsvpProcess', 'welcome' );
            $http.put( ENV.apiEndpoint + '/ribyt/rsvp/' + $sessionStorage.inviteHash, data )
                .then( function success ( resp ) {
                    if ( cb ) {
                        return cb( null, resp );
                    }
                }, function error ( resp ) {
                    if ( cb ) {
                        return cb( resp );
                    }
                } );
        };

        $rootScope.getRequiredFields = function ( paramsRequired, paramsEnabled ) {
            return _.flatten( Object.keys( paramsRequired ).map( function ( key ) {
                if ( typeof paramsRequired[key] === 'object' ) {
                    return _.flatten( $rootScope.getRequiredFields( paramsRequired[key], paramsEnabled ? paramsEnabled[key] : null ) );
                } else {
                    return paramsRequired[key] && paramsEnabled && paramsEnabled[key] ? key : null;
                }
            } ) ).filter( Boolean );
        };

        $rootScope.setRSVPToFinalYes = function ( invitation ) {
            return $rootScope.setRSVPToYes( invitation, function accept ( error, response ) {
                if ( error && _.get( error, 'data.error_description' ) === 'This invite does not exist' ) {
                    // This error makes sense here if they refreshed.
                    return notificationService.error( 'Sorry but this invite does not exist.' );
                }

                _.set( $sessionStorage, 'invitation', response.data.data );
                _.set( $rootScope, 'rsvp', 'y' );
                invitation = $rootScope.decryptInvite( _.get( $sessionStorage, 'invitation' ) );

                // Send them to the complete page
                return $state.go( 'main.complete', {
                    'inviteHash': _.get( $rootScope, 'inviteHash', null )
                }, { 'reload': true } );
            } );
        };

        /**
         * Local helper functions
         */

        /**
         * This is a vernam cipher that basically works like a rot13 but with a specific
         * string to rotate against. It's not secure and can easily be undone so don't rely
         * on it for strict security.
         *
         * However, what I am using it for is for obscurity. The RSVP API endpoints will
         * all return a vernam cipher of whatever their normal response should be. Thus,
         * that cipher must be unscrambled here. I am doing this inside of each controller
         * and saving it to a local var and not entirely to $rootScope or $scope. I'm doing
         * this because anything in scope is easily seen and we want some form of obscurity
         * even if this data belongs to the user themselves.
         *
         * @param msg
         * @param key
         * @returns {*}
         */
        function v ( msg, key ) {
            if ( typeof msg !== 'string' ) {
                return null;
            }

            var l = key.length;
            var fromCharCode = String.fromCharCode;
            return msg.replace( /[\s\S]/g, function ( c, i ) {
                return fromCharCode( key.charCodeAt( i % l ) ^ c.charCodeAt( 0 ) );
            } );
        }
        /**
         * End global custom functions
         */

        /**
         * Stuff to run on every page load. This runs before any resolves and controllers.
         */

        /**
         * Check for the old rsvp URL style (/?inviteHash=...) vs the new one (/#/...)
         */
        var path = window.location.href.replace( window.location.origin, '' );
        var urlPattern = /^\/#\//;

        if ( window.location.search && !urlPattern.test( urlPattern ) ) {
            /**
             * If there is a .search property, then it's likely the user is using
             * the legacy RSVP url. We need to change that inject the # in the right place.
             *
             */
            window.location = window.location.origin + '/#/' + window.location.search;
            return false;
        }

        // Must have inviteHash. Set the parameters to root scope if they get lost in routing.
        _.set( $rootScope, 'parameters', $location.search() );
        _.set( $rootScope, 'inviteHash', _.get( $rootScope.parameters, 'inviteHash' ) || _.get( $sessionStorage, 'inviteHash' ) );

        // Set the session inviteHash
        _.set( $sessionStorage, 'inviteHash', _.get( $rootScope, 'inviteHash' ) );

        // Set the preview value. This must match the inviteID in the verify controller.
        if ( _.get( $rootScope, 'parameters.preview' ) ) {
            _.set( $sessionStorage, 'preview', _.get( $rootScope, 'parameters.preview' ) );
        }
        /*
        phantomJS for some reason generates the PDF with a view of XS.
        We have to use the pdfView flag to adjust for the PDF to generate
        correctly and also to display it correctly if they're viewing on mobile.
        This mostly affects the barcode for an actify byt and the hotel check-in/out
        */
        _.set( $sessionStorage, 'pdfView', _.get( $rootScope, 'parameters.pdf', false ) );

        // upon each state change, we need to make sure they don't go backwards
        $rootScope.$on( '$stateChangeStart', function ( event, next, current, fromState, fromParams ) {
            // give a value for each step. This will prevent the user from going to a lower ranked spot during the RSVP process
            var progressRanking = [
                {
                    'position': '',
                    'rank': 0
                },
                {
                    'position': 'introduction',
                    'rank': 0
                },
                {
                    'position': 'guestProfile',
                    'rank': 1
                },
                {
                    'position': 'legalForms',
                    'rank': 2
                },
                {
                    'position': 'companionInvitation',
                    'rank': 3
                },
                {
                    'position': 'welcome',
                    'rank': 4
                }
            ];

            var completed = _.find( progressRanking, {'position': $rootScope.rsvpProcess} );
            var wantedPage = _.find( progressRanking, { 'position': next.rsvpProcess } );

            if ( next.rsvpProcess === 'guestProfile' && $rootScope.allowEditPersonalInfo || next.rsvpProcess === 'introduction' && $rootScope.allowEditRSVP || next.rsvpProcess === 'permission' ) {
                return;
            }

            // do not allow the page to change if they are trying to go back in the system
            if ( _.get( wantedPage, 'rank', 0 ) < _.get( completed, 'rank', 0 ) && $rootScope.rsvpProcess ) {
                event.preventDefault();
            }
        } );
    } )
.filter( 'moment', function ( moment ) {
    return function ( input, format ) {
        if ( !format ) {
            format = 'MMM Do YYYY';
        } // default date format

        // Hack for old date format, results of 'datetimeStart.toString()'
        if ( input.trim().length > 25 ) {
            return moment( moment( input ).utc().format( 'ddd MMM DD YYYY HH:mm:ss' ) ).format( format );
        }

        var utcDate = moment.utc( input );
        if ( !utcDate.isValid() ) {
            var parseFormat = null;
            if ( input.match( /^\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2}$/ ) ) {
                parseFormat = 'YYYY-MM-DD HH:mm:ss';
            } else if ( input.match( /^\w{3},\s*\d{2}\s+\w{3}\s+\d{4}\s+\d{2}:\d{2}:\d{2}\s+([-+][0-9]{2}[0-5][0-9]|(?:UT|GMT|(?:E|C|M|P)(?:ST|DT)|[A-IK-Z]))/ ) ) {
                parseFormat = 'ddd DD MMM YYYY HH:mm:ss ZZ';
            } else if ( input.match( /^\w{3},\s*\w{3}\s+\d{2}\s+\d{4}\s+\d{2}:\d{2}:\d{2}\s+([-+][0-9]{2}[0-5][0-9]|(?:UT|GMT|(?:E|C|M|P)(?:ST|DT)|[A-IK-Z]))/ ) ) {
                parseFormat = 'ddd MMM DD YYYY HH:mm:ss ZZ';
            }
            utcDate = moment.utc( input, parseFormat );
        }

        return utcDate.format( format );
    };
} )
/**
 * Service to do all dynamic variable substitutions.
 */
.service( 'variableSubstitution', function varSub ( $rootScope, $sessionStorage ) {
    this.doSubstitutions = doSubstitutions;

    function doSubstitutions ( text, invitation ) {
        // if there is no invite sent
        if ( !invitation ) {
            // the session invitation could change from service initiation so cannot use caching here
            // this makes sure the data is the freshest available RPT-2548
            // do this calculation each time to make sure this is the newest data
            invitation = $rootScope.decryptInvite( _.get( $sessionStorage, 'invitation' ) );
        }

        if ( !text || !invitation ) {
            return text;
        }

        var event = invitation.eventID;
        var venue = _.get( event, 'location.venue', '' ).trim();
        var hasLocation = venue || _.get( event, 'location.formatted_location', false );

        var digitalLink = _.get( event, 'digitalLink', '' ).trim();

        var eventLocation;
        if ( hasLocation ) {
            eventLocation = [_.get( event, 'location.city' ), _.get( event, 'location.state' ), venue].filter( Boolean ).join( ', ' );
        } else {
            eventLocation = '<a href="' + digitalLink + '">Event Link</a>';
        }

        var substitutions = [{
            'key': '[guest.name.first]',
            'value': _.get( invitation, 'guestID.name.first' )
        }, {
            'key': '[guest.name.last]',
            'value': _.get( invitation, 'guestID.name.last' )
        }, {
            'key': '[guest.title]',
            'value': _.get( invitation, 'guestID.name.title' )
        }, {
            'key': '[host.name.first]',
            'value': _.get( invitation, 'invitedByUserID.name.first' )
        }, {
            'key': '[host.name.last]',
            'value': _.get( invitation, 'invitedByUserID.name.last' )
        },
        {
            'key': '[group.senderEmail]',
            'value': _.get( invitation, 'experienceID.emailDetails.senderEmail' )
        }, {
            'key': '[group.senderName]',
            'value': _.get( invitation, 'experienceID.emailDetails.senderName' )
        },
        {
            'key': '[host.email]',
            'value': _.get( invitation, 'invitedByUserID.email.primary' )
        }, {
            'key': '[host.title]',
            'value': _.get( invitation, 'invitedByUserID.name.title', '' )
        }, {
            'key': '[host.company]',
            'value': _.get( invitation, 'invitedByUserID.companyName', '' )
        }, {
            'key': '[event.name]',
            'value': ( _.get( invitation, 'experienceID.isGroupNamePriority' ) ) ? _.get( invitation, 'experienceID.name', '' ) : _.get( invitation, 'eventID.name', '' )
        }, {
            'key': '[event.dateStart]',
            'value': moment( _.get( invitation, 'eventID.dateStart', '' ) ).format( 'MMM Do YYYY' )
        }, {
            'key': '[event.dateEnd]',
            'value': moment( _.get( invitation, 'eventID.dateEnd', '' ) ).format( 'MMM Do YYYY' )
        }, {
            'key': '[event.location]',
            'value': eventLocation
        }, {
            'key': '[event.digitalLink]',
            'value': '<a href="' + digitalLink + '">Event Link</a>'
        }, {
            'key': '[rsvp.url]',
            'value': _.get( invitation, 'inviteHash' )
        }
        ];

        // add companion stuff if necessary
        if ( invitation.type === 'g' ) {
            substitutions.push( {
                'key': '[companion.name.first]',
                'value': _.get( invitation, 'guestID.name.first' )
            }, {
                'key': '[companion.name.last]',
                'value': _.get( invitation, 'guestID.name.last' )
            }, {
                'key': '[companion.title]',
                'value': _.get( invitation, 'guestID.name.title' )
            } );
        }

        _.each( substitutions, function ( value, key ) {
            if ( typeof text === 'string' ) {
                if ( value.value ) {
                    text = text.split( value.key ).join( value.value );
                } else {
                    text = text.split( value.key ).join( '' );
                }
            }
        } );
        return text;
    };
} )
.service( 'mainInviteRequest', function ( $rootScope, $sessionStorage, notificationService, ENV, $http, $q, $state, $location, messageDictionary, $timeout ) {
    this.getInvite = function () {
        var inviteHash = _.get( $rootScope, 'inviteHash' );
        var gid = _.get( $rootScope, 'parameters.gid', null );

        if ( $rootScope.inviteNotFound ) {
            return $rootScope.encryptInvite( {'data': {'data': 'gian'}} );
        } else if ( inviteHash ) {
            // Always get the invite on load
            return $http.get( ENV.apiEndpoint + '/ribyt/rsvp/' + inviteHash )
                .then( function success ( resp ) {
                    var data = _.get( resp, 'data.data' );
                    var newInvite = data && $rootScope.decryptInvite( data );

                    if ( newInvite && newInvite.inviteHash !== inviteHash ) {
                        _.set( $rootScope, 'inviteHash', newInvite.inviteHash );
                        _.set( $rootScope, 'inviteHashRedirect', newInvite.inviteHash );
                        _.set( $sessionStorage, 'inviteHash', newInvite.inviteHash );

                        var redirectData = {
                            inviteHash: resp.data.redirect
                        };
                        if ( _.get( $rootScope, 'parameters.preview' ) ) {
                            redirectData.preview = _.get( $rootScope, 'parameters.preview' );
                        }
                        if ( _.get( $rootScope, 'parameters.showTicket', false ) ) {
                            redirectData.showTicket = _.get( $rootScope, 'parameters.showTicket' );
                        }

                        $timeout( function () {
                            return $location.search( redirectData );
                        }, 200 );
                    }

                    return data;
                } )
                .catch( function error ( resp ) {
                    // notificationService.error( 'Sorry but we could not find your invitation.' );
                    $rootScope.inviteNotFound = resp.data.data;
                    return $state.go( 'error', {
                        'message': _.get( resp, 'data.error_description', messageDictionary.error.generalContactSupport ),
                        'inviteHash': _.get( $rootScope, 'inviteHash', null )
                    } );
                } );
        } else if ( gid ) {
            /**
             * If they passed a GID then this is a public registration. Grab the necessary info and make a fake invite record.
             */

            return $http.get( ENV.apiEndpoint + '/ribyt/rsvp/tempInvite/' + gid )
                .then( function success ( resp ) {
                    return _.get( resp, 'data.data' );
                } )
                .catch( function error ( resp ) {
                    notificationService.error( resp.data.data );
                    $rootScope.inviteNotFound = resp.data.data;
                    return $state.go( 'error', {
                        'message': messageDictionary.error.generalContactSupport,
                        'inviteHash': _.get( $rootScope, 'inviteHash', null )
                    } );
                } );
        } else {
            // use the passed information as invite information
            return $q( function ( resolve, reject ) {
                if ( _.get( $rootScope, 'parameters.invite' ) ) {
                    resolve( _.get( $rootScope, 'parameters.invite' ) );
                } else {
                    notificationService.error( messageDictionary.error.noInvite );
                    reject( messageDictionary.error.noInvite );
                }
            } );
        }
    };
} )
    .factory( '$bootbox', ['$uibModal', function ( $uibModal ) {
        // NOTE: this is a workaround to make BootboxJS somewhat compatible with
        // Angular UI Bootstrap in the absence of regular bootstrap.js
        if ( $.fn.modal == undefined ) {
            $.fn.modal = function ( directive ) {
                var that = this;
                if ( directive == 'hide' ) {
                    if ( this.data( 'bs.modal' ) ) {
                        this.data( 'bs.modal' ).close();
                        $( that ).remove();
                    }
                    return;
                } else if ( directive == 'show' ) {
                    return;
                }

                var modalInstance = $uibModal.open( {
                    'template': $( this ).find( '.modal-content' ).html()
                } );
                this.data( 'bs.modal', modalInstance );
                setTimeout( function () {
                    $( '.modal.ng-isolate-scope' ).remove();
                    $( that ).css( {
                        'opacity': 1,
                        'display': 'block'
                    } ).addClass( 'in' );
                }, 100 );
            };
        }

        return bootbox;
    }] )
.factory('messageDictionary', function () {
    return {
        'error': {
            'completeRSVPIssue': 'There was an error completing your RSVP. Please contact support.',
            'inviteSaveIssue': 'Sorry but there was a problem saving your invitation.',
            'generalContactSupport': 'Sorry but there seems to be an error. Please contact support.',
            'noInvite': 'Sorry but we could not find your invitation.',
            'fillCompanionInfo': 'Please fill out all the companion info OR check the box indicating you will not be having a companion',
            'saveError': 'Sorry but there was a problem saving your information. Please try again',
            'emailNotMatch': 'Sorry, but that email does not match this invitation.'
        },
        'general': {
            'acceptButtonText': "I'm so there!",
            'declineButtonText': "I can't make it.",
            'acceptGuestMessage': "Great! We have received all of your information and you have successfully RSVP'd to this event!!",
            'declineGuestMessage': 'We are sorry you can’t make it. :(',
            'inUse': ' is already in use for another guest.',
            'companionEmailUnique': 'Companion emails must be unique.',
            'required': 'This is a required field.'
        },
        'buttons': {
            'saveAndCont': 'Save & Continue',
            'retry': 'Click here to try again'
        }
    };
}).factory( 'RibytUtils', [ '$http', 'ENV', function RibytUtils ( $http, ENV ) {
    return {
        flattenObject: flattenObject,
        defineBytVisibility: defineBytVisibility,
        stringVersionOfAirport: stringVersionOfAirport,
        searchAirports: searchAirports
    };

    function searchAirports ( search ) {
        return $http
            .get( ENV.apiEndpoint + '/ribyt/rsvp/searchAirports/?q=' + search, {} )
            .then( function handler ( response ) {
                return response.data;
            } );
    }

    function stringVersionOfAirport ( place ) {
        var airportStringInfo = place.name;
        if ( place.iata ) {
            airportStringInfo += ' (' + place.iata + ') ';
        }
        if ( place.city ) {
            airportStringInfo += place.city;
        }
        if ( place.stateCode ) {
            airportStringInfo += ', ' + place.stateCode;
        }

        if ( place.countryCode !== 'US' ) {
            airportStringInfo += ', ' + place.countryName;
        }

        return airportStringInfo;
    }

    function defineBytVisibility ( arr, flag, $scope, invite ) {
        var airByts = [];
        var hotelByts = [];
        var isOpenReg = _.get( invite, 'experienceID.RSVPDetails.isAllowPublicRSVP' );

        if ( isOpenReg ) {
            _.cloneDeep( invite.byts ).map( function ( byt ) {
                if ( byt.bytID.type === 'Air' ) {
                    airByts.push( byt );
                } else if ( byt.bytID.type === 'Hotel' ) hotelByts.push( byt );
            } );
        }

        var field;
        switch ( flag ) {
        case 'showAirDeclineOption':
            arr = isOpenReg ? airByts : arr;
            field = 'isGuestCantDeclineAir';
            break;
        case 'showHotelDeclineOption':
            arr = isOpenReg ? hotelByts : arr;
            field = 'isGuestCantDeclineHotel';
            break;
        default:
            console.err( 'unknown flag for defineBytVisibility' );
        }

        arr.map( function map ( byt ) {
            var state;
            if ( _.get( invite, 'type' ) === 'i' ) {
                state = byt.qty > 0 && !_.get( invite, 'experienceID.RSVPDetails[' + field + ']' );
            } else {
                state = byt.qtyCompanion > 0 && !_.get( invite, 'experienceID.RSVPDetails[' + field + ']' );
            }
            _.set( $scope, flag, state );
        } );
    }

    function flattenObject ( ob ) {
        var toReturn = {};

        for ( var i in ob ) {
            if ( !ob.hasOwnProperty( i ) ) {
                continue;
            }

            if ( ( typeof ob[i] ) === 'object' ) {
                var flatObject = flattenObject( ob[i] );
                for ( var x in flatObject ) {
                    if ( !flatObject.hasOwnProperty( x ) ) {
                        continue;
                    }

                    toReturn[i + '.' + x] = flatObject[x];
                }
            } else {
                toReturn[i] = ob[i];
            }
        }
        return toReturn;
    }
} ] );
